<template>
  <div class="i-phone">
    <div class="i-phone__screen">
      <div class="i-phone__sender">
        {{ sender_name }}
      </div>

      <div class="i-phone__sms">
        <div class="i-phone__sms-box">
          {{ body || $t('mailer.mailing.form.block.sms.placeholder') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      body: {
        type: String,
        default: ''
      },
      sender_name: {
        type: String,
        default: ''
      }
    }
  };
</script>
<style lang="scss">
  .i-phone {
    width: 440px;
    height: 450px;
    background-image: url('/img/other/mailer-phone.svg');
    background-repeat: no-repeat;
    background-size: 100%;
    margin: auto;
    background-position: top center;

    &__screen {
      margin-top: 107px;
      display: inline-block;
      margin-left: 57px;
      width: 327px;
    }
    &__sender {
      height: 44px;
      width: 100%;
      padding: 0 $spacer;
      text-align: center;
      font-size: 18px;
      line-height: 44px;
      font-weight: 600;
    }

    &__sms {
      max-height: 297px;
      padding-bottom: 25px;
      overflow: auto;
      position: relative;
    }
    &__sms-box {
      margin-left: 10px;
      margin-top: 20px;
      width: 285px;
      position: relative;
      box-sizing: border-box;
      border-radius: 15px;
      background: #ecedf1;
      color: #0f151a;
      word-break: break-word;
      font-size: 18px;
      text-align: left;
      padding: 12px 12px 12px 12px;

      &:after {
        content: '';
        width: 14px;
        height: 11px;
        background-image: url('/img/other/mailer-sms-corner.png');
        position: absolute;
        left: -4px;
        bottom: 0;
      }
    }
  }
</style>
